import React from 'react';
import { FaLinkedin, FaTwitter, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3><span className="logo-icon">📊</span> Taxave</h3>
          <p>AI Powered Suite for Tax Professionals</p>
          <div className="footer-social">
            <a href="#"><FaLinkedin /></a>
            <a href="#"><FaTwitter /></a>
            <a href="#"><FaYoutube /></a>
          </div>
        </div>
        <div className="footer-section">
          <h4>Quick Links</h4>
          <a href="#services">Services</a>
          <a href="#contact">Contact</a>
          <a href="#">Privacy Policy</a>
          <a href="#">Terms of Service</a>
        </div>
        <div className="footer-section">
          <h4>Products</h4>
          <a href="#">Income Tax Software</a>
          <a href="#">Project Report Software</a>
          <a href="#">Net Worth Certificate</a>
          <a href="#">GST Compliance</a>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2026 Taxave. All rights reserved. Powered by Mr.Jana</p>
      </div>
    </footer>
  );
};

export default Footer;